import "../../styles/alerts/alert.css";
import { MdGppGood } from "react-icons/md";
import { IoMdInformationCircle } from "react-icons/io";
import { RiErrorWarningFill } from "react-icons/ri";
import { IoCloseCircleSharp } from "react-icons/io5";
import { IoClose } from "react-icons/io5";
import { useState, useEffect } from "react";

export const ModalAlert = ({ type, title = "something went wrong", message = "Please try again later", showAlert, setAlertDisplay }) => {
  useEffect(() => {
    let divNode = document.querySelector(".alertModalWrapper");
    divNode.style.transform = showAlert ? "translateY(0)" : "translateY(-200px)";
    setTimeout(() => {
      divNode.style.transform = "translateY(-200px)";
      setAlertDisplay((prev) => ({ ...prev, showAlert: false }));
    }, 6000);

    return () => {};
  }, [type, showAlert]);

  let backgroundColor =
    type === "success" ? "#F1F8F4" : type === "error" ? "#F5E9E5" : type === "info" ? "#E4ECF7" : type === "warning" ? "#F9F4E7" : "#2196f3";

  let iconColor = type === "success" ? "#4FDB6B" : type === "error" ? "#F65253" : type === "info" ? "#3084E7" : type === "warning" ? "#F9BD24" : "#2196f3";

  let borderColor = type === "success" ? "#DCEDDF" : type === "error" ? "#EDD3CC" : type === "info" ? "#B4CDED" : type === "warning" ? "#F4E3C5" : "#2196f3";

  return (
    <>
      <div className='alertModalWrapper'>
        <div style={{ backgroundColor, border: `1px solid ${borderColor} ` }} className='alertModal12'>
          <div style={{ backgroundColor: iconColor }} className='alertIconDIv'>
            <div style={{ color: iconColor }}>
              {type === "success" ? (
                <MdGppGood />
              ) : type === "error" ? (
                <IoCloseCircleSharp />
              ) : type === "info" ? (
                <IoMdInformationCircle />
              ) : (
                <RiErrorWarningFill />
              )}
            </div>
          </div>
          <div className='titleWorth'>
            <h5>{title}</h5>
            <p> {message} </p>
          </div>
          <div onClick={() => setAlertDisplay(false)} className='closeModalAlert'>
            <IoClose />
          </div>
        </div>
      </div>
    </>
  );
};
